import React, { useState } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from 'reactstrap'
import { convertToTicket } from '../../helpers/chat_helper'

const TicketForm = ({ isOpen, toggle, conversationId, onSuccess }) => {
  const [formData, setFormData] = useState({
    subject: '',
    description: '',
    priority: 'medium',
    category: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!formData.subject.trim()) {
      setError('Subject is required')
      return
    }

    try {
      setLoading(true)
      setError(null)
      
      const response = await convertToTicket(conversationId, formData)
      
      if (onSuccess) {
        onSuccess(response.data?.data || response.data)
      }
      
      // Reset form
      setFormData({
        subject: '',
        description: '',
        priority: 'medium',
        category: ''
      })
      
      toggle()
    } catch (err) {
      console.error('Error converting to ticket:', err)
      setError(err.response?.data?.message || 'Failed to create ticket')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Convert to Ticket</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {error && (
            <Alert color="danger" toggle={() => setError(null)}>
              {error}
            </Alert>
          )}

          <FormGroup>
            <Label for="subject">Subject *</Label>
            <Input
              type="text"
              name="subject"
              id="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Enter ticket subject"
              required
            />
          </FormGroup>

          <FormGroup>
            <Label for="description">Description</Label>
            <Input
              type="textarea"
              name="description"
              id="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe the issue..."
              rows="4"
            />
          </FormGroup>

          <FormGroup>
            <Label for="priority">Priority</Label>
            <Input
              type="select"
              name="priority"
              id="priority"
              value={formData.priority}
              onChange={handleChange}
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="urgent">Urgent</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label for="category">Category</Label>
            <Input
              type="text"
              name="category"
              id="category"
              value={formData.category}
              onChange={handleChange}
              placeholder="e.g., Booking Issue, Payment, Technical"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create Ticket'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default TicketForm
